// Configuration for different environments
const config = {
  development: {
    // Use environment variable set in .env.development
    apiUrl: process.env.REACT_APP_API_URL,
  },
  production: {
    // Use environment variable set during build/deployment
    apiUrl: process.env.REACT_APP_API_URL,
  },
  test: {
    apiUrl: process.env.REACT_APP_API_URL || "http://localhost:3000",
  },
};

// Determine the current environment based on NODE_ENV or default to development
const env = process.env.NODE_ENV || "development";

// Export the configuration for the current environment
export default config[env];
